<!-- HTML Part -->
<style scoped>
.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
.no-spinner {
    -moz-appearance: textfield;
}
</style>

<template>
  <div>
    <!-- Heading -->
    <h5 class="card-title">{{ title }}</h5>
    <br />
    <!-- 1st Line -->

    <div style="width: 100%; display: flex">
      <div style="width: 50%; margin-right: 20px">
        <label :style="labelStyle" >เลขที่ใบอนุญาต</label>
        <div style="display: flex; gap: 10px; align-items: center;">
          <input
            ref="refNoInput"
            v-model="inputNo"
            type="number"
            maxlength="10"
            class="form-control no-spinner"
            :class="{ 'is-invalid': errorsNo }"
            @keypress="isNumber($event)"
          />
          <!-- Search Button -->
          <b-button
            variant="primary"
            @click="searchLicense"
            :disabled="!inputNo"
          >
            <i class="bi bi-search"></i>
          </b-button>
        </div>
        <b-form-invalid-feedback v-if="errorsNo" style="display: block;">
          <p>{{ errorsNo }}</p>
        </b-form-invalid-feedback>
      </div>
      <div style="width: 50%">
        <label :style="labelStyle" >วันใบอนุญาตหมดอายุ</label>
        <input
          ref="refExpInput"
          v-model="inputExp"
          type="text"
          class="form-control"
          readonly
        />
      </div>
    </div>
    <br />
    <!-- 2nd Line -->
    <div style="width: 100%; display: flex">
      <div style="width: 50%; margin-right: 20px">
        <label :style="labelStyle" >ชื่อ - นามสกุล</label>
        <input
            ref="refNameInput"
            v-model="inputName"
            type="text"
            class="form-control"
            readonly
        />
      </div>
      <div style="width: 50%">
        <label :style="labelStyle" >รหัสบริษัทต้นสังกัด</label>
        <input
            ref="refcompCodeInput"
            v-model="inputCompCode"
            type="text"
            class="form-control"
            readonly
        />
      </div>
    </div>
    <b-form-text v-if="nameMatching" style="display: block;">
        <p style="color: #856404;">{{ nameMatching }}</p>
    </b-form-text>
    <br />
    <!-- 3nd Line -->
    <div style="width: 100%; display: flex">
      <div style="width: 50%; margin-right: 20px">
        <label :style="labelStyle" >ชื่อบริษัทต้นสังกัด</label>
        <input
            ref="refCompNameInput"
            v-model="inputCompName"
            type="text"
            class="form-control"
            readonly
        />
      </div>
      <div style="width: 50%">
        <label v-if="licenseForm === 'LIFE'" :style="labelStyle" >รหัสตัวแทน/นายหน้าประกันชีวิต</label>
        <label v-else-if="licenseForm === 'NONLIFE'" :style="labelStyle" >รหัสตัวแทน/นายหน้าประกันวินาศภัย</label>
        <input
            ref="reftypeCodeInput"
            v-model="inputTypeCode"
            type="text"
            class="form-control"
            readonly
        />
      </div>
    </div>
    <br />
    <!-- 4nd Line -->
    <div style="width: 100%; display: flex">
      <div style="width: 50%; margin-right: 20px">
        <label v-if="licenseForm === 'LIFE'" :style="labelStyle" >ประเภทตัวแทน/นายหน้าประกันชีวิต</label>
        <label v-else-if="licenseForm === 'NONLIFE'" :style="labelStyle" >ประเภทตัวแทน/นายหน้าประกันวินาศภัย</label>
        <input
            ref="refTypeInput"
            v-model="inputTypeName"
            type="text"
            class="form-control"
            readonly
        />
      </div>
      <div style="width: 50%">
        <label :style="labelStyle" >ประเภทการอบรม</label>
        <input
            ref="refLevelInput"
            v-model="renewLevelText"
            type="text"
            class="form-control"
            readonly
        />
      </div>
    </div>
    <br />

    <b-button
      variant="dark"
      class="float-right"
      style="margin-right: 10px;"
      :disabled='disableUpdateButton'
      @click="update()"
      >บันทึกข้อมูล</b-button
    >
  </div>
</template>

<!-- Javascript Part -->
<script>
//Import
//--Vue Component
import "vue-select/dist/vue-select.css";
import api from "@/services/api.js";
import axios from "axios";
//Export
export default {
  //--Vue Component
  components: {},
  //--Class Property
  props: {
    title: { type: String, default: null },
    id: { type: Number, default: null },
    fullName: { type: String, default: null },
    mpFirstName: { type: String, default: null },
    mpLastName: { type: String, default: null },
    compCode: { type: String, default: null },
    compName: { type: String, default: null },
    licenseTypeName: { type: String, default: null },
    licenseForm: { type: String, default: null },
    type: { type: String, default: null },
    typeCode: { typeCode: String, default: null },
    no: { type: String, default: null },
    expF: { type: String, default: null },
    exp: { type: String, default: null },
    trHrs: { type: String, default: null },
    card: { type: String, default: null },
    opt: { type: Array, default: null },
    lReducedHours: { type: Number, default: null },
    nlReducedHours: { type: Number, default: null },
    level: { type: String, default: null },
    errors: { type: String, default: "" },
    method: { type: String, default: "POST" }
  },
  data() {
    return {
      //Global Variables
      mId: this.$route.params.id,
      comId: localStorage.getItem("ComId"),
      token: localStorage.getItem("token"),
      baseUrl:
        process.env.VUE_APP_FILE_ACCESS_SERVICE_URL ||
        "https://cs-file-access-service-20220815.coursesquare.com",
      //Local
      minDate: this.no
        ? new Date().toISOString().split('T')[0]
        : null,
      config: {
        "content-type": "multipart/form-data",
        token: localStorage.getItem("token")
      },
      formData: new FormData(),
      renewLevelStyle: {
        color: '#183F80',
        backgroundColor: '#D1E4FD',
        margin: '10px',
        padding: '10px',
        'font-size': '14px',
      },
      renewLevelText: '',
      renewNonlifeLevelText: '',
      spanText: '',
      linkHref: '',
      isChecked: false,
      inputName: this.fullName,
      inputCompCode: this.compCode,
      inputCompName: this.compName,
      inputTypeCode: this.typeCode,
      inputTypeName: this.licenseTypeName,
      inputLevel: this.level,
      inputNo: this.no,
      errorsNo: "",
      inputExp: this.expF,
      errorsExp: "",
      inputTrHrs: this.trHrs,
      errorsTrHrs: "",
      errorsCard: "",
      errorsType: "",
      nameMatching: "",
      licenseIssuedAt: null,
      insuranceCard: null,
      isChangeInsuranceCard: false,
      insuranceCardPath: null,
      previewInsuranceCardSrc: null,
      disableUpdateButton: true,
      labelStyle: {
        fontWeight: 'bold',
      }
    };
  },
  mounted() {
    if (this.type) {
      this.formData.append("insuranceType", this.type);
    }
    if (this.type == "LIFE_BROKER" || this.type == "LIFE_AGENT") {
      this.isChecked = this.lReducedHours ? true : false;
      this.spanText = "การประกันชีวิต";
      this.linkHref = "https://www.oic.or.th/sites/default/files/content/91695/prakaas-hlaksuutrprakanchiiwit-rabfangkhwaamehn.pdf";
    } else if (this.type == "NONLIFE_BROKER" || this.type == "NONLIFE_AGENT") {
      this.isChecked = this.nlReducedHours ? true : false;
      this.spanText = "ประกันวินาศภัย";
      this.linkHref = "https://www.oic.or.th/sites/default/files/content/91695/prakaas-hlaksuutrprakanwinaasphay-rabfangkhwaamkhidehn.pdf";
    }
    if(this.level){
      this.renewLevelText += this.level == "RENEW1" 
        ? "ขอต่ออายุใบอนุญาต ครั้งที่ 1" 
        : this.level == "RENEW2"
        ? "ขอต่ออายุใบอนุญาต ครั้งที่ 2"
        : this.level == "RENEW3"
        ? "ขอต่ออายุใบอนุญาต ครั้งที่ 3"
        : this.level == "RENEW4"
        ? "ขอต่ออายุใบอนุญาต ครั้งที่ 4"
        : null;
    }
  },

  methods: {
    modalHideEditInsuranceForm() {
      this.$emit("modalHideEditInsuranceForm");
    },
    onKeyPress(event) {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }
    },
    isNumber(evt) {
      const char = String.fromCharCode(evt.which);
      if (!/[0-9]/.test(char)) {
        evt.preventDefault();
      }
    },
    getIns() {
      this.$emit("getIns");
    },
    async update() {
      let insuranceData = {};
      if (!this.inputNo) {
        this.errorsNo = "กรุณากรอกเลขที่ใบอนุญาต";
        return;
      } else {
        this.errorsNo = null;
      }
      if (!this.errorsNo) {
        if(this.isChangeInsuranceCard){
          await this.updateInsuranceCard();
        }
        const [day, month, year] = this.inputExp.split('/');
        if (this.licenseForm == "LIFE") {
          let typeCode = this.inputTypeCode;
          let licenseType = '';

          if (typeCode == '01' || typeCode == '07') {
            licenseType = 'LIFE_AGENT';
            this.inputTrHrs = this.inputLevel == "RENEW1" || this.inputLevel == "RENEW2" || this.inputLevel == "RENEW3" ? 6 : (this.inputLevel == "RENEW4" ? 30 : null);
          } else if (typeCode == '03') {
            licenseType = 'LIFE_BROKER';
            this.inputTrHrs = this.inputLevel == "RENEW1" || this.inputLevel == "RENEW2" || this.inputLevel == "RENEW3" ? 10 : (this.inputLevel == "RENEW4" ? 50 : null);
          }

          insuranceData = {
            id: this.id,
            lCard: this.isChangeInsuranceCard ? this.insuranceCardPath : this.card,
            lExp: `${year}-${month}-${day}`,
            lTypeCode: this.inputTypeCode,
            lTypeName: this.inputTypeName,
            lLicenseIssuedAt: this.licenseIssuedAt,
            lLevel: this.inputLevel,
            nlNo: null,
            lNo: this.inputNo,
            lTrHrs: this.inputTrHrs,
            lType: licenseType,
            lReducedHours: this.isChecked
          }
        } else if (this.licenseForm == "NONLIFE") {
          let typeCode = this.inputTypeCode;
          let licenseType = '';

          if (typeCode == '02' || typeCode == '05' || typeCode == '06' || typeCode == '08') {
            licenseType = 'NONLIFE_AGENT';
            this.inputTrHrs = this.inputLevel == "RENEW1" || this.inputLevel == "RENEW2" || this.inputLevel == "RENEW3" ? 6 : (this.inputLevel == "RENEW4" ? 30 : null);
          } else if (typeCode == '04') {
            licenseType = 'NONLIFE_BROKER';
            this.inputTrHrs = this.inputLevel == "RENEW1" || this.inputLevel == "RENEW2" || this.inputLevel == "RENEW3" ? 10 : (this.inputLevel == "RENEW4" ? 50 : null);
          }
          
          insuranceData = {
            id: this.id,
            lNo: null,
            nlCard: this.isChangeInsuranceCard ? this.insuranceCardPath : this.card,
            nlExp: `${year}-${month}-${day}`,
            nlTypeCode: this.inputTypeCode,
            nlTypeName: this.inputTypeName,
            nlLicenseIssuedAt: this.licenseIssuedAt,
            nlLevel: this.inputLevel,
            nlNo: this.inputNo,
            nlTrHrs: this.inputTrHrs,
            nlType: licenseType,
            nlReducedHours: this.isChecked
          }
        }
        this.disableUpdateButton = true;
        await api
          .post(`/v1/insurance/${this.mId}/update`, {
            ins: insuranceData
          })
          .then(() => {
            this.$emit("getIns");
            this.$emit("modalHideEditInsuranceForm");
            this.disableUpdateButton = false;
          })
          .catch(error => {
            this.disableUpdateButton = false;
            console.log("[Error] Insurace Update - " + error);
          });
      }
    },
    previewInsuranceCard(event) {
      this.isChangeInsuranceCard = true;
      const file = event.target.files[0];
      let extension = file.type.split("/")[1];
      if (!(extension == "jpeg" || extension == "jpg" || extension == "png")) {
        this.errors = "อัปโหลดรูปภาพไม่สำเร็จ โปรดเลือกเฉพาะไฟล์ .png .jpg .jpeg เท่านั้น";
        return;
      }
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.previewInsuranceCardSrc = e.target.result;
        };
        reader.readAsDataURL(file);
        this.errorsCard = null;
      } else {
        this.previewInsuranceCardSrc = null;
      }
    },

    searchLicense() {
      this.errorsNo = "";
      this.nameMatching = "";
      this.disableUpdateButton = true;
      this.inputName = null;
      this.inputTypeCode = null;
      this.inputTypeName = null;
      this.inputExp = null;
      this.inputCompCode = null;
      this.inputCompName = null;
      this.inputLevel = null;
      this.renewLevelText = "";
      this.licenseIssuedAt = null;
      const mpFullName = this.mpFirstName + " " + this.mpLastName;
      if(this.inputNo == null){
        return;
      }
      api.get(`v1/insurance-oic/${this.inputNo}/data`).then(({ data }) => {
        const licenseTypeCode = data?.data?.LICENSE_TYPE_CODE;

        const isLifeInvalid = this.licenseForm === "LIFE" &&
          ["04", "02", "05", "06", "08"].includes(licenseTypeCode);

        const isNonlifeInvalid = this.licenseForm === "NONLIFE" &&
          ["01", "03", "07"].includes(licenseTypeCode);

        if(data.data == null || isLifeInvalid || isNonlifeInvalid){
          this.errorsNo = "ไม่พบข้อมูลใบอนุญาต";
          this.disableUpdateButton = true;
          return;
        }

        if(data.data['LICENSE_EXPIRED']){
          this.errorsNo = "ใบอนุญาตนี้หมดอายุแล้ว! ไม่สามารถใช้งานได้";
          this.disableUpdateButton = true;
          return;
        }
        
        this.inputName = data.data['NAMES'] + " " + data.data['LASTNAME'];

        if(this.inputName != mpFullName){
          this.nameMatching = "ข้อมูลชื่อ - นามสกุลไม่ตรงกับข้อมูลที่แจ้งกับ คปภ. กรุณาแก้ไขข้อมูลให้ถูกต้อง";
        }

        this.inputTypeCode = data.data['LICENSE_TYPE_CODE'];
        this.inputTypeName = data.data['LICENSE_TYPE_NAME'];
        
        const [year, month, day] = data.data['EXPIRE_DATE'].split('-');
        this.inputExp = `${day}/${month}/${year}`;

        this.inputCompCode = data.data['COMP_CODE'];
        this.inputCompName = data.data['COMP_NAME'];
        this.inputLevel = data.data['LICENSE_LEVEL'];
        this.licenseIssuedAt = data.data['DATE_LICENSE_ACT'];
        if(data.data['LICENSE_LEVEL']){
          this.renewLevelText += data.data['LICENSE_LEVEL'] == "RENEW1" 
            ? "ขอต่ออายุใบอนุญาต ครั้งที่ 1" 
            : data.data['LICENSE_LEVEL'] == "RENEW2"
            ? "ขอต่ออายุใบอนุญาต ครั้งที่ 2"
            : data.data['LICENSE_LEVEL'] == "RENEW3"
            ? "ขอต่ออายุใบอนุญาต ครั้งที่ 3"
            : data.data['LICENSE_LEVEL'] == "RENEW4"
            ? "ขอต่ออายุใบอนุญาต ครั้งที่ 4"
            : "";
        }
        this.disableUpdateButton = false;
      });
    },

    async updateInsuranceCard() {
      const formCardData = new FormData();
      formCardData.append('insuranceType', this.type);
      formCardData.append('insuranceCard', this.insuranceCard);
      await axios({
        url: this.baseUrl + `/companies/${this.comId}/members/${this.mId}/images/insurance-card/`,
        data: formCardData,
        method: this.method,
        headers: this.config
      }).then(result => {
          let response = result.data;
          this.insuranceCardPath = response.insuranceCardPath;
        })
        .catch(error => {
          this.formData.delete('insuranceCard');
          console.log("[Error] ImgUpload - " + error);
        });
    },
  }
};
</script>